import { QueryClient } from "@tanstack/react-query";

// HTTP
export const protocol = `${process.env.REACT_APP_API_PROTOCOL || 'https://'}`;
export const hostname = `${process.env.REACT_APP_API_HOST}`;
//export const port = process.env.REACT_APP_API_PORT;//`${process.env.REACT_APP_API_PORT || '443'}`;
// export const context = process.env.REACT_APP_API_CONTEXT;
export const domain = `${protocol}${hostname}/`;
export const requestTimeout = Number(
  `${process.env.REACT_APP_HTTP_REQUEST_TIMEOUT_MS || 10000}`
);

// Client
export const connectClientId = `${process.env.REACT_APP_CONNECT_CLIENT_ID || 'CONNECTION_PORTAL'}`;
export const connectClientSecret = `${process.env.REACT_APP_CONNECT_CLIENT_SECRET}`;
export const authconst = btoa(`${connectClientId}:${connectClientSecret}`);


//Misc
export const connectionsApiUrl = `${domain}social-api/connections/`;
export const testimonialsApiUrl = `${domain}social-api/testimonials/`;


export const headers = {
  "Content-Type": "application/json",
  Authorization: "Basic " + authconst,
};

export const SESSION_STORAGE_KEY = "connections:portal:session";
export const PARAMETERS_STORAGE_KEY = "connections:portal:parameters";
export const CHATBOT_COOKIE_KEY = "chatbotUrl";

export const queryClient = new QueryClient();

export const redirectToConnectHome = () =>{
  window.location.href= `/web/secure/home`;
}

// Removes / at end of input string 
export const stripTrailingSlash = (str) => {
  return str.endsWith('/') ?
      str.slice(0, -1) :
      str;
};

export const isFieldNotEmpty = (field) => {
  if(field!=="" && field!==null){
   return true;
  }
  return false;
}

export const getCookie = (name) => {
  const cookieString = document.cookie;
  const cookies = cookieString.split("; ");
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=");
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
};